import axios from 'axios';
import { app_version } from './Utils';
import { SalesOrderItemLoading } from './Models';

export const serverUrl = `${process.env.REACT_APP_SERVER_URL+ '/api' || ''}`;

axios.defaults.headers.post['Content-Type'] ='application/json';

const ArthaGateway = {
    validateLogin: async function(username, password) {
        try {
            const payload = { username: username, password: password };
            let response = await axios.post(serverUrl + '/master/employee/validate', payload);
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::validateLogin ->"+ error);
            throw error;
        }
        return false;
    },
    getTrips: async function(durationId: string, status: number, pageNumber: number = 1, pageSize: number = 1000) {
        try {
            const params = { durationId, status, pageNumber, pageSize  };
            let response = await axios.get(serverUrl + '/vehicle/tripMaster', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTrips ->"+ error);
            throw error;
        }
        return undefined;
    },
    getTrip: async function(id: number) {
        try {
            let response = await axios.get(serverUrl + '/vehicle/tripMaster/' + id);
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTrip ->"+ error);
            throw error;
        }
        return undefined;
    }, 
    getOrder: async function(id: number) {
        try {
            let response = await axios.get(serverUrl + '/voucher/order/' + id);
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getOrder ->"+ error);
            throw error;
        }
        return undefined;
    },
    getTripByCode: async function(code: string) {
        try {
            //let response = await axios.get(serverUrl + '/voucher/trip?code=' + code);
            let response = await axios.get(serverUrl + '/voucher/trip/' + code);
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTrip ->"+ error);
            throw error;
        }
        return undefined;
    },
    markTripAsLoaded: async function(tripId: number) {
        try {
            let response = await axios.get(serverUrl + '/voucher/trip/load?tripId='+ tripId);
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::completePacking ->"+ error);
            throw error;
        }
        return false;
    },
    markPackageAsLoaded: async function(loadingDetails: SalesOrderItemLoading) {
        try {
            let response = await axios.post(serverUrl + '/voucher/order/loading', loadingDetails);
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::completePacking ->"+ error);
            throw error;
        }
        return false;
    },
    unloadOrder: async function(orderId: number, tripId: number) {
        try {
            let response = await axios.get(serverUrl + '/voucher/trip/unload?tripId='+ tripId + '&orderId='+ orderId);
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::completePacking ->"+ error);
            throw error;
        }
        return false;
    },
    updateVehicleDetails: async function(vehicleData: any) {
        try {
            let response = await axios.post(serverUrl + '/voucher/trip/updateVehicle', vehicleData);
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::updateVehicleDetails ->"+ error);
            throw error;
        }
        return false;
    },
    getEmployees: async function(name, groupId, pageNumber = 1, pageSize = 100) {
        try {
            const params = { name, groupId, pageNumber, pageSize, activeOnly: true, fields: 'Id,Name,EmployeeNumber,GroupName,PseudoName'  };
            let response = await axios.get(serverUrl + '/master/employee', { params });
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getEmployees ->"+ error);
            throw error;
        }
        return undefined;
    },    
    getProductionPlants: async function(employeeId: number) {
        try {
            const params = { employeeId };
            let response = await axios.get(serverUrl + '/employee/productionPlant', { params });
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getProductionPlants ->"+ error);
            throw error;
        }
        return undefined;
    },
    postGatepass: async function(gatepass) {
        try {
            let response = await axios.post(serverUrl + '/attendance/gatepass', gatepass);
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::postGatepass ->"+ error);
            throw error;
        }
        return undefined;
    },
    getGatepass: async function(employeeId, durationId) {
        try {
            const params = { employeeId, durationId  };
            let response = await axios.get(serverUrl + '/attendance/gatepass', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getGatepass ->"+ error);
            throw error;
        }
        return undefined;
    },
}

export default ArthaGateway;